import * as Utils from '../utils/common-utils'
import { CSVProfile, CSVTranformationProfile, IDataPoint } from '../../types'
import {
 LegendClickHandlers,
 MwChartStackedPercentageColumnOptions,
} from '@meltwater/mw-visualizations-angularjs'
import { prettyNames } from '../../charts-factory'
import { BaseVisualization } from '../base/base-visualization-component'
import angular from 'angular'

export class StackedColumnComponent extends BaseVisualization {
 static config = {
  selector: 'afStackedColumn',
  controller: StackedColumnComponent,
  template: `
    <mw-chart-stacked-percentage-column
    ng-if="!$ctrl.isLoading && !$ctrl.isObjEmpty($ctrl.visualizationDataArray)"
    chart-data="$ctrl.visualizationDataArray"
    chart-options="$ctrl.visualizationOptions"
    get-api="$ctrl.getApi(API)">
    </mw-chart-stacked-percentage-column>
    `,
  bindings: BaseVisualization.config.bindings,
 }

 public onLegendClick = LegendClickHandlers.HIDE_SERIES
 public seriesColors

 // default CSV header columns. Can be overriden in sub class.
 public csvHeaders = ['Category', 'Count']
 public transformationProfiles: CSVTranformationProfile[] = []
 public toolTipLabel

 $onChanges(changes) {
  if (this.hasChanges(changes.visualizationMetaData)) {
   this.setMetaData(changes.visualizationMetaData.currentValue)
  }
  if (changes.vizData && typeof changes.vizData.currentValue !== 'undefined') {
   if (!this.isObjEmpty(changes.vizData.currentValue.data)) {
    this.setProperties()
    this.updateData(changes.vizData.currentValue.data)
    this.updateOptions()
    this.buildCSVExportProfile()
   } else {
    this.visualizationDataArray = []
   }
  }
 }

 setProperties() {}

 updateData(data) {
  this.visualizationDataArray = this.isObjEmpty(data) ? [] : this.buildChartData(data)
 }

 updateOptions() {
  this.visualizationOptions = this.buildChartOptions()
 }

 buildChartData(data: IDataPoint[]) {
  let dataContainer = []

  if (Object.keys(data).length === 2) {
   delete data['all']
  }
  Object.keys(data).map(key => {
   if (key !== 'TVEyes') {
    data[key].map(objData => {
     let indexFind = dataContainer.findIndex(x => x.name === objData.key)
     if (indexFind >= 0) {
      dataContainer[indexFind].data.push({
       key: prettyNames(key),
       value: objData.value,
       code: objData.code,
      })
     } else {
      dataContainer.push({
       name: objData.key,
       data: [
        {
         key: prettyNames(key),
         value: objData.value,
         code: objData.code,
        },
       ],
      })
     }
    })
   }
  })

  dataContainer = dataContainer.map(x => {
   x.name = this.prettyNames(x.name)
   return x
  })

  return dataContainer
 }

 compareChartData = (data, metaData) => {
  let dataContainer = []
  let idx

  metaData.forEach(element => {
   dataContainer.push({
    name: element.name,
    data: [],
   })
  })

  Object.keys(data).forEach(key => {
   metaData.forEach(query => {
    idx = data[key].findIndex(x => x.key === query.name)
    if (idx === -1) {
     data[key].push({
      key: query.name,
      value: 0,
     })
    }
   })
  })

  Object.keys(data).forEach(key => {
   data[key].forEach(dataItem => {
    let indexFind = dataContainer.findIndex(x => x.name === dataItem.key)
    if (indexFind === -1) {
    } else {
     dataContainer[indexFind].data.push({
      key: prettyNames(key),
      value: dataItem.value,
      code: dataItem.code,
     })
    }
   })
  })

  return dataContainer
 }

 tooltipFormatter = point => {
  return `<strong>Source:</strong> ${point.key}<br> <strong>${this.toolTipLabel ||
   'Sentiment'}</strong> ${point.seriesName}<br> <strong>Value:</strong> ${point.value}`
 }

 onPointClick = obj => {
  let payload = [
   this.updatePayload(
    'FILTER_CHANGE',
    'append',
    'sentiment',
    this.getSentimentType(obj.seriesName)
   ),
   this.updatePayload(
    'FILTER_CHANGE',
    'append',
    'sourceType',
    this.getSourceCode(obj.key, obj.seriesName)
   ),
  ]
  this.triggerUpdate(payload)
 }

 buildChartOptions() {
  return new MwChartStackedPercentageColumnOptions({
   tooltipFormatter: this.tooltipFormatter,
   ...(this.isChartClickable() ? { onPointClick: this.onPointClick } : undefined),
   seriesColors: this.seriesColors,
   onLegendClick: this.onLegendClick,
  })
 }

 prettyNames(data) {
  switch (data) {
   case 'p':
    data = 'Positive'
    break
   case 'n':
    data = 'Neutral'
    break
   case 'v':
    data = 'Negative'
    break
   case 'u':
    data = 'Not Rated'
    break
   default:
    break
  }
  return data
 }

 setColorPalette(data) {
  let palette = []
  data.map(x => {
   switch (x.name) {
    case 'Positive':
     palette.push('#75B000')
     break
    case 'Neutral':
     palette.push('#E0E0E0')
     break
    case 'Negative':
     palette.push('#D0021D')
     break
    case 'Not Rated':
     palette.push('#BDBDBD')
     break
    default:
     palette.push('#BDBDBD')
     break
   }
  })
  return palette
 }

 getSentimentType(SentimentType: string) {
  switch (SentimentType) {
   case 'Positive':
    return 'p'
    break
   case 'Neutral':
    return 'n'
    break
   case 'Negative':
    return 'v'
    break
   case 'Not Rated':
    return 'u'
    break
   default:
    break
  }
 }

 getSourceCode(key, seriesName) {
  return this.visualizationDataArray.find(x => x.name === seriesName).data.find(z => z.key === key)
   .code
 }

 exportCSV() {
  // overview data
  let exportData = {}
  angular.copy(this.vizData.data, exportData)
  Utils.excludeKey(exportData, 'code')

  //   this.csvOptions.title = this.visTitle
  //   this.csvOptions.headers = ['Category', 'Count']
  //   this.csvExporter.options = this.csvOptions
  //   this.csvExporter.generateCsvFromArrayObject([exportData])
 }

 buildCSVExportProfile() {
  this.csvExportProfiles = []

  let exportData: CSVProfile = {
   data: Object.assign({}, this.vizData.data),
   csvOptions: { title: this.visTitle, headers: this.csvHeaders },
   transformationProfiles: this.transformationProfiles,
  }

  this.csvExportProfiles.push(exportData)
 }
}
